import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import Header from "../components/Header";
import ImageIcon from '@mui/icons-material/Image';
import { useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from '../axios.js';

const TryAndBuyReceipt = () => {
  const { t } = useTranslation();
  const { trackingNumber } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const pin = queryParams.get('pin');
  const [stopLoading, setStopLoading] = useState(false)
  const [orderData, setOrderData] = useState({});

  const loadOrder = () => {
    axios.get(`delivery-order/${trackingNumber}/?pin=${pin ? pin : ''}`)
      .then((response) => {
        setOrderData(response.data);
      })
      .catch(() => {})
      .finally(() => {
        setStopLoading(true)
      });
  }

  useEffect(() => {
    loadOrder();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackingNumber, pin]);
  
  return (
    <div className="flex flex-col h-screen">
      <div className={stopLoading ? '' : 'show-modal loading-window fixed inset-0 z-20'}>
        <div id="loading"></div>
      </div>

      <Header />
      <div className="flex-grow mt-[80px] flex items-center justify-center p-4 main">
        <div className="max-w-full w-[375px] p-6 bg-white rounded-xl border shadow-sm">
          <h2 className="text-center text-darkblue text-lg font-bold mb-5 border-b pb-2">{ t('Order Receipt') }</h2>
          {
            orderData.buy_and_try_product_in_order ?
            (
              <>
                <div className="space-y-3">
                  {orderData.buy_and_try_product_in_order.map((item) => (
                    <div key={item.id} className="flex items-center justify-between gap-3 border-b pb-3 last:pb-0 last:border-none">
                      {/* Image */}
                      {
                        item.product_image_url ? (
                          <img src={item.product_image_url} alt={item.product_name} className="w-14 h-14 p-1 rounded-md object-contain border flex-shrink-0" />
                        ) : (
                          <div className="w-14 h-14 p-1 rounded-md object-contain border flex-shrink-0 flex items-center justify-center">
                            <ImageIcon className="text-gray-300" />
                          </div>
                        )
                      }
                      
                      {/* Details */}
                      <div className="flex-1">
                        <p className="font-semibold text-darkblue">{ item.product_name }</p>
                        <p className="text-xs text-[#8599B3]">{ t('Qty') }: { item.delivered_quantity }</p>
                      </div>

                      {/* Price */}
                      <div className="text-right">
                        <p className="text-sm font-medium text-darkblue leading-6">{ t('EGP') } { (item.unit_price * item.delivered_quantity).toFixed(2) }</p>
                        <p className="text-xs text-[#8599B3]">{ t('Unit Price') }: { t('EGP') } { item.unit_price.toFixed(2) }</p>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Total */}
                <div className="border-t pt-2 mt-5 text-darkblue">
                  <div className="flex font-medium text-sm items-center justify-between gap-4">
                    <p>{ t('Shipping Fees') }</p>
                    <p>{ t('EGP') } { orderData.buy_and_try_shipping_fees.toFixed(2) }</p>
                  </div>
                  <div className="flex items-center justify-between gap-4 mt-1">
                    <p className="font-medium">
                      { t('Total') }
                      <span className="text-xs">{ ' ' + t('(including shipping fees)') }</span>
                    </p>
                    <p className="text-lg font-semibold leading-6">{ t('EGP') } { orderData.cash_amount.toFixed(2) }</p>
                  </div>
                </div>
              </>
            ) : (
              <p className="text-center text-gray-500">
                { t('No receipt data available for this order.') }
              </p>
            )
          }
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TryAndBuyReceipt;